import { ResourcesListingFilter } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import {
  ListedResource,
  ListingPage,
  toListedResource,
  toListingBody,
} from "../utils/resourcesListing";

type Response = {
  _embedded: {
    resources: ListedResource[];
  };
  page: ListingPage;
};

function getPlanzoneResourcesListing(httpClient: HttpClient) {
  return (filter: ResourcesListingFilter) =>
    httpClient
      .sendHttpRequest<Response>({
        endpoint: "/resources/listing",
        method: HttpMethods.POST,
        data: toListingBody(filter),
      })
      .then(({ _embedded, page }) => ({
        resources: _embedded.resources.map(toListedResource),
        totalPages: page.totalPages || 1,
      }))
      .catch((e) => Promise.reject({ ...e, message: e.detail || "" }));
}

export { getPlanzoneResourcesListing };
